import React from "react";

const PaymentFailed = () => {
  return (
    <div style={styles.body}>
      <div style={styles.cross} className="shake">
        <span style={styles.crossIcon}>✖</span>
      </div>
      <div style={styles.message}>Payment Failed</div>
      <div style={styles.subtext}>Something went wrong. Please try again.</div>

      {/* Inline animation style */}
      <style>
        {`
          @keyframes shake {
            0% { transform: rotate(0deg); }
            25% { transform: rotate(-10deg); }
            50% { transform: rotate(10deg); }
            75% { transform: rotate(-10deg); }
            100% { transform: rotate(0deg); }
          }
          .shake {
            animation: shake 0.4s ease-out;
          }
          @media (max-width: 600px) {
            .cross {
              width: 70px !important;
              height: 70px !important;
            }
            .cross span {
              font-size: 2rem !important;
            }
            .subtext {
              font-size: 1.5rem !important;
            }
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  body: {
    margin: 0,
    padding: 20,
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: "#fff5f5",
    color: "#c53030",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "100vh",
    textAlign: "center",
  },
  cross: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    backgroundColor: "#f56565",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
  },
  crossIcon: {
    fontSize: "3rem",
    color: "white",
  },
  message: {
    fontSize: "1.6rem",
    fontWeight: 600,
    maxWidth: "90%",
  },
  subtext: {
    fontSize: "1rem",
    marginTop: "10px",
    color: "#4a5568",
  },
};

export default PaymentFailed;
